import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Payment } from '@models/account.model';
import { TranslateService } from '@ngx-translate/core';
import { ConfigLocaleService } from '@services/configLocale.service';
import { TagManagerService } from '@services/tag-manager.service';
import { Observable, of } from 'rxjs';
@Component({
  selector: 'gc-payment-display-card',
  templateUrl: './payment-display-card.component.html',
  styleUrls: ['./payment-display-card.component.scss'],
  standalone: false,
})
export class PaymentDisplayCardComponent implements OnInit {
  @Input() payment: Payment;

  currencyCode$: Observable<string>;
  paidButton: string;
  locale: string = this.configService.$defaultLanguage();

  private readonly router = inject(Router);
  private readonly tagManagerService = inject(TagManagerService);

  constructor(
    private readonly configService: ConfigLocaleService,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.currencyCode$ = of(this.configService.$currencyCode());
    this.paidButton = this.payment.paid ? this.translateService.instant('view_invoice') : this.translateService.instant('pay_now');
    this.locale = this.translateService.currentLang || this.configService.$defaultLanguage();
  }

  googleAnalytics(event: Event) {
    const gtmTag = {
      event: 'flow-tracking',
      page: this.router.url,
      type: (event.target as HTMLButtonElement).innerText,
      stage: 'payment',
    };
    this.tagManagerService.pushTag(gtmTag);
  }
}
